export default __webpack_public_path__ + "static/media/my-port.28c15022.gif";